module.exports = __webpack_public_path__ + "img/red-desert-1.a74b98a5.png";